export default "__VITE_ASSET__BzFc9EXJ__"